module.exports = __webpack_public_path__ + "static/media/inf_23og24.cee9cf22.mp3";